export default class automationSettings {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/automation/directives/automation-settings.html'),
            scope: {
                automation: '=',
                tags: '=',
                segments: '=',
                customDateFields: '='
            },
            controller: [
                '$scope', '$element', '$attrs', '$filter', '$timeout', '$state', '$rootScope', '$window', 'Events', 'Automation', 'Tag', 'Segment', 'SweetAlert',
                (scope, element, attr, $filter, $timeout, $state, $rootScope, $window, Events, Automation, Tag, Segment, SweetAlert) => {
                var originalName = angular.copy(scope.automation.name);
                var expandedAutomation = $window.localStorage.getItem('settings.automation.expanded');

                scope.isMaximized = expandedAutomation == scope.automation.id;
                scope.triggerType = scope.automation.trigger != null ? scope.automation.trigger.type : 'tag';

                var initAutomation = () => {
                    scope.numActiveMessages = 0;

                    angular.forEach(scope.automation.messages, (message) => {
                        message.standardTrigger = message.segment_id ? false : true;

                        if (message.active && ! message.removed) {
                            scope.numActiveMessages++;
                        }
                    });
                };

                initAutomation();

                // deprecated
                var countPending = () => {
                    Automation.subscriberPendingMessageCount(scope.automation.id).then((countsByMessage) => {
                        var lastCount = 0;
                        scope.totalPending = 0;
                        angular.forEach(countsByMessage, (count) => {
                            angular.forEach(scope.automation.messages, (message) => {
                                if (count.id == message.id) {
                                    message.numPending = count.count - lastCount;
                                    lastCount = count.count;
                                    scope.nonPendingCount -= message.numPending;
                                }
                            });
                        });
                    });
                };


                scope.toggleMaximized = (event) => {
                    var target = $(event.target);

                    if (! target.is('input') &&
                        ! target.is('.bootstrap-switch-label') &&
                        ! target.is('button') &&
                        ! target.is('span')
                    ) {
                        scope.isMaximized = ! scope.isMaximized;

                        if (! scope.isMaximized) {
                            initAutomation();
                            $window.localStorage.removeItem('settings.automation.expanded', scope.automation.id);
                        } else {
                            $window.localStorage.setItem('settings.automation.expanded', scope.automation.id);
                        }
                    }
                };

                scope.countNumMessages = () => {
                    var numMessages = 0;

                    angular.forEach(scope.automation.messages, (message) => {
                        if (! message.removed) {
                            numMessages++;
                        }
                    });

                    return numMessages;
                };

                scope.switchTriggerType = () => {
                    scope.triggerType = scope.triggerType == 'tag' ? 'segment' : 'tag';
                };

                scope.updateNameHandler = () => {
                    $(element).find('.automation-name-input').blur();
                };

                scope.updateName = () => {
                    if (scope.automation.name.length && scope.automation.name != originalName) {
                        Automation.updateName(scope.automation.id, scope.automation.name).then(() => {
                            Events.flashEvent('notification', $filter('translate')('AUTOMATION:FLASH:NAME_UPDATED'));
                            originalName = angular.copy(scope.automation.name);
                        }, (error) => {
                            Events.flashEvent('error', $filter('translate')('AUTOMATION:FLASH:NAME_UPDATED_FAILED'));
                        });
                    }
                };

                scope.addTrigger = (trigger, automation) => {
                    Automation.addTrigger(automation.id, trigger.id, scope.triggerType).then((response) => {
                        scope.automation['trigger'] = response;
                        Events.flashEvent('notification', $filter('translate')('AUTOMATION:FLASH:TRIGGER_UPDATED'));
                    })
                };

                scope.toggleAutomationActivation = (automation) => {
                    if (automation.active) {
                        Automation.activate(automation.id).then(() => {
                            scope.$emit('automation:switchStatus');
                            Events.flashEvent('notification', $filter('translate')('AUTOMATION:FLASH:ACTIVATED_EXPLAINED'));
                        });
                    } else {
                        SweetAlert.swal({
                            title: $filter('translate')('AUTOMATION:FLASH:DEACTIVATE_HEADER'),
                            text: $filter('translate')('AUTOMATION:FLASH:DEACTIVATE_BODY'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: $filter('translate')('GLOBAL:YES'),
                            cancelButtonText: $filter('translate')('GLOBAL:NO')
                        }, (isConfirm) => {
                            if (isConfirm) {
                                Automation.deactivate(automation.id).then(() => {
                                    scope.$emit('automation:switchStatus');
                                    Events.flashEvent('notification', $filter('translate')('AUTOMATION:FLASH:DEACTIVATED_EXPLAINED'));
                                });
                            } else {
                                // Reactivate automation.
                                automation.active = true;
                            }
                        });
                    }
                };

                scope.removeAutomation = () => {
                    SweetAlert.swal({
                            title: $filter('translate')('GLOBAL:FLASH:DELETE'),
                            text: $filter('translate')('AUTOMATION:FLASH:DELETE_AUTOMATION_EXPLAINED'),
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: $filter('translate')('GLOBAL:YES'),
                            cancelButtonText: $filter('translate')('GLOBAL:NO')
                        },
                        (isConfirm) => {
                            if (isConfirm) {
                                Automation.remove(scope.automation.id).then(() => {
                                    Events.flashEvent('notification', $filter('translate')('AUTOMATION:FLASH:DELETED'));
                                    scope.automation['removed'] = true;
                                    scope.$emit('automation:removed');
                                }, () => {
                                    SweetAlert.swal({
                                        title: $filter('translate')('GLOBAL:FLASH:OOPS'),
                                        text: $filter('translate')('GLOBAL:FLASH:DELETE_ERROR'),
                                        type: 'error'
                                    });
                                });
                            }
                        }
                    )
                };
            }]
        }
    }
}
